package planet

class Planet(val regions: List<List<Region>> = listOf()) {
}
